import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { cn } from "@repo/ui/utils";
interface EditorialGlyphProps {
  className?: string;
  "data-testid"?: string;
}
export function EditorialGlyph(t0) {
  const $ = _c(7);
  const {
    className,
    "data-testid": t1
  } = t0;
  const testId = t1 === undefined ? "editorial-glyph" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("size-12 shrink-0 text-brand-secondary desktop-sm:size-18", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M 38.446 27.007 L 38.446 3.655 L 38.886 0 L 33.776 0 L 34.216 3.655 L 32.253 26.973 C 32.253 29.884 29.884 32.253 27.007 32.253 C 24.13 32.253 11.033 33.573 3.655 34.216 L 0 33.776 L 0 38.886 L 3.655 38.446 L 27.007 38.446 C 33.302 38.446 38.446 33.302 38.446 27.007 Z" />;
    t4 = <path d="M 69.345 34.588 L 46.027 34.588 C 39.732 34.588 34.588 39.732 34.588 46.027 L 34.588 69.345 L 34.148 73 L 39.258 73 L 38.818 69.345 L 40.781 46.027 C 40.781 43.116 43.15 40.747 46.027 40.747 C 48.904 40.747 62.001 39.427 69.379 38.784 L 73.034 39.224 L 73.034 34.114 L 69.379 34.554 L 69.345 34.588 Z" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== testId) {
    t5 = <svg viewBox="0 0 73.034 73" fill="currentColor" aria-hidden="true" className={t2} data-testid={testId}>{t3}{t4}</svg>;
    $[4] = t2;
    $[5] = testId;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}